import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { CancelScheduleAppointmentDetailsResponse, getCancelReScheduleAppointmentDetailsByPhone } from 'services';

export type State = ApiState<CancelScheduleAppointmentDetailsResponse, SerializedError>;

export const fetchCancelScedAppointmentDetailsByPhone = createAsyncThunk(
  'get/cancelScheduledAppointments',
  async () => await getCancelReScheduleAppointmentDetailsByPhone()
);

export const initialState = {
  isLoading: false,
  hasLoaded: false,
  data: [],
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const cancelSchedAppointmentDetailsByPhoneSlice = createSlice({
  name: 'cancelSchedAppointmentDetailsByPhone',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCancelScedAppointmentDetailsByPhone.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(
      fetchCancelScedAppointmentDetailsByPhone.fulfilled,
      (state, action: PayloadAction<CancelScheduleAppointmentDetailsResponse>) => {
        state.isLoading = false;
        state.data = action.payload;
        state.hasLoaded = true;
      }
    );

    builder.addCase(fetchCancelScedAppointmentDetailsByPhone.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const cancelSchedAppointmentStateSelector_ = (state: { cancelSchedAppointmentDetailsByPhone: State }): State =>
  state.cancelSchedAppointmentDetailsByPhone;

export const cancelSchedAppointmentDetailsByPhone_ = createSelector(
  cancelSchedAppointmentStateSelector_,
  (state) => state.data
);

export default cancelSchedAppointmentDetailsByPhoneSlice.reducer;
